import { Table } from 'react-bootstrap'
import Pagination from '../../shared/Pagination'
import Skeleton from 'react-loading-skeleton'
import { formatDate } from 'utils'
const APIURL = process.env.REACT_APP_API_URL_RESOURCE
export function TableJustifications({ reports, loading, pagination, getReports }) {
    const handlePage = (page) => {
        getReports(page)
    }

    return (
        <Table className='align-middle'>
            <thead>
                <tr>
                    <th>Fecha</th>
                    <th>Docente</th>
                    <th>Materia</th>
                    <th>Justificación</th>
                    <th className='text-center'>Documento</th>
                </tr>
            </thead>
            <tbody>
                {reports?.length > 0 ? (
                    reports.map((value) => {
                        return (
                            <tr key={value.id}>
                                <td>{formatDate(value.date, 'd/m/Y')}</td>
                                <td className='text-nowrap'>{value.nombre}</td>
                                <td>
                                    <span className='text-nowrap'>{value.materia_name}</span> - Grupo {value.grupo}
                                </td>
                                <td>{value.justificacion_text}</td>
                                <td className='text-center'>
                                    {value.url_document ? (
                                        <a href={`${APIURL}${value.url_document}`} target='_blank' rel='noreferrer'>
                                            Ver
                                        </a>
                                    ) : (
                                        '-'
                                    )}
                                </td>
                            </tr>
                        )
                    })
                ) : (
                    <tr style={{ textAlign: 'center' }}>
                        <td colSpan={5}>
                            {loading ? <Skeleton count={4} height={40} /> : 'No existen justificaciones'}
                        </td>
                    </tr>
                )}

                <tr>
                    <td colSpan={5}>
                        {reports?.length > 0 && (
                            <Pagination
                                totalRecords={pagination.totalRecords}
                                rowsPerPage={pagination.pageSize}
                                page={pagination.currentPage}
                                onPage={handlePage}
                                paginationReport={`Mostrando ${pagination.offset + 1}-${
                                    pagination.offset + reports.length
                                } de ${pagination.totalRecords} items.`}
                            />
                        )}
                    </td>
                </tr>
            </tbody>
        </Table>
    )
}
